var Theme = Theme || {};

Theme.ConferencesBrowseByYear = (function ($) {

    var baseSiteUrl = $('#hfSiteURL').val();

    return {
        init: _init
    };

    function _init() {
        setDecadeClickEvent();
        setYearClickEvent();
        setConferenceItemClickEvent();
    }

    function setDecadeClickEvent() {
        $('.master-main').on('click', '.js-bby-decade', _handleDecadeClick);
    }

    function _handleDecadeClick(e) {
        let $eventTarget = $(e.currentTarget);
        let eTargetDecade = $eventTarget.data('decade');
        let $decadeLinks = $('.js-bby-decade');
        let $matchingDecadeYears = $('.js-bby-decadeYears').find(`[data-decade="${eTargetDecade}"]`);
        let $defaultYear = $matchingDecadeYears.children('.js-bby-year').last();

        if ($eventTarget.hasClass('selected')) {
            return;
        }

        _moveSelectedClassToNewElement($decadeLinks, $eventTarget);
        _revealMatchingDecadeYears($matchingDecadeYears, $defaultYear);
    }


    function _revealMatchingDecadeYears($matchingDecadeYears, $defaultYear) {
        $('.js-bby-years').addClass('hide');

        if ($matchingDecadeYears.length) {
            $matchingDecadeYears.removeClass('hide');
        }

        $('.js-bby-year').removeClass('selected');

        if ($defaultYear.length) {
            $defaultYear.trigger('click');
        }
    }

    function setYearClickEvent() {
        $('.master-main').on('click', '.js-bby-year', _handleYearClickEvent);
    }

    function _handleYearClickEvent(e) {
        let $eventTarget = $(e.currentTarget);
        let targetYearValue = $eventTarget.data('year');
        let $yearLinks = $('.js-bby-year');

        if ($eventTarget.hasClass('selected')) {
            return;
        }

        _moveSelectedClassToNewElement($yearLinks, $eventTarget);
        _getConferencesByYear(targetYearValue);
    }

    function _moveSelectedClassToNewElement($oldElement, $newElement) {
        $oldElement.removeClass('selected');
        $newElement.toggleClass('selected');
    }

    function _getConferencesByYear(year) {        
        let ajaxUrl = `//${baseSiteUrl}/Proceeding/ConferenceListByYear`;
        let ajaxData = { year: year };

        SCM.Ajax.get(ajaxUrl, ajaxData)
            .expectHtml()
            .then(_populateConferenceList)
            .catch(console.error);

        function _populateConferenceList(ajaxResult) {
            let $conferenceListLocation = $('.js-bby-conferenceList');
            if (ajaxResult.length) {
                $conferenceListLocation.html(ajaxResult);
            } else {
                $conferenceListLocation.html('No conferences were found for the selected year.');
            }
        }

    }

    function setConferenceItemClickEvent() {
        $('.master-main').on('click', '.js-conference-list-item', _handleConferenceItemClick);
    }

    function _handleConferenceItemClick(e) {
        let $eventTarget = $(e.currentTarget);
        let conferenceId = $eventTarget.closest('.js-conference-list-resources-item').attr('data-conferenceId');
        let $volumeListElement = $(`.js-conference-volume-list[data-conferenceId="${conferenceId}"]`);

        if ($volumeListElement.html().trim().length == 0) {
            _getVolumeListByConferenceId(conferenceId);
        }

        $eventTarget.find('i').toggleClass('icon-general-add icon-general_minus');
        $volumeListElement.toggleClass('hide');
    }
    
    function _getVolumeListByConferenceId(conferenceId) {
        let volumeListLocationId = $(`.js-conference-volume-list[data-conferenceId="${conferenceId}"]`);
        let ajaxUrl = `//${baseSiteUrl}/Proceeding/ConferenceVolumeListResources`;
        let ajaxData = { conferenceId: conferenceId };

        SCM.Ajax.get(ajaxUrl, ajaxData)
            .expectHtml()
            .then(_populateProceedingsList)
            .catch(console.error);

        function _populateProceedingsList(ajaxResult) {
            $(volumeListLocationId).html(ajaxResult);
        }
    }

})(jQuery);
